import React from 'react'
import { cn } from '../lib/cn'

export function DialogBackdrop({ className, children, ...props }) {
    return (
        <div
            className={cn(
                'fixed inset-0 z-[70] flex items-end justify-center bg-slate-950/45 sm:items-center sm:p-4',
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}

export function DialogPanel({ className, children, role = 'dialog', ariaModal = true, ...props }) {
    return (
        <div
            role={role}
            aria-modal={ariaModal}
            className={cn(
                'flex max-h-[calc(100dvh-1rem)] w-full max-w-lg flex-col overflow-hidden rounded-t-xl border border-sgez-border-strong bg-sgez-surface shadow-xl',
                'sm:max-h-[90dvh] sm:rounded-xl',
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}

export function DialogHeader({ className, children, ...props }) {
    return (
        <header
            className={cn(
                'flex shrink-0 items-start justify-between gap-4 border-b border-sgez-border bg-sgez-surface px-4 py-3 sm:px-5 sm:py-4',
                className
            )}
            {...props}
        >
            {children}
        </header>
    )
}

export function DialogBody({ className, children, ...props }) {
    return (
        <div
            className={cn('min-h-0 flex-1 overflow-y-auto bg-sgez-surface px-4 py-4 sm:px-5', className)}
            {...props}
        >
            {children}
        </div>
    )
}

export function DialogFooter({ className, children, ...props }) {
    return (
        <footer
            className={cn(
                'flex shrink-0 flex-col-reverse gap-2 border-t border-sgez-border bg-sgez-surface-subtle px-4 py-3',
                'sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:px-5 sm:py-4',
                className
            )}
            {...props}
        >
            {children}
        </footer>
    )
}
